
// Authentication APIs
export const changePassword ="/password/change";

// User Details APIs
export const userProfileStatic = "/user/profile/static";
export const userEventList = "/user/event/list";
export const userGeneralProfile = "/user/profile/general";
export const getProfile ="/user/profile/detail";
export const getUserAddress = "/user/address/list";
export const saveUserAddress = "/user/address/save";
export const updateUserAddress = "/user/address/update";
export const saveGeneralProfile ="/user/profile/general";
export const getUsercoupons ="/sponsor/coupons";
export const getUsercouponsV2 ="/sponsor/coupons";
export const uploadUserProfile="/user/profile/pic/upload";
export const getUserPreferences = "/user/preference/whatsapp";
export const saveWhatsappCommunication ="/user/preference/whatsapp";
export const sendOtpOnPhone ="/user/verification/send/sms";
export const sendOtpOnPhoneAddress="/user/address/send/sms";
export const sendOtpOnEmail ="/user/verification/send/email";
export const sendOtpOnEmailVerification="/user/verification/verify/email";
export const deactivateAccount="/user/account/delete";
export const getAttemptsPull = "/user/pull/attempts.htm";
export const saveStaticProfile="/user/profile/static"
export const getuserRunData= "/user/run/list/filtered";
export const getUserRideData = "/user/ride/list/filtered";
export const getStepsData="/user/steps/list";
export const getSkipActivity="/skipped/list.htm";
export const workoutDtlsURL = "/user/workout/list";
export const exerciseDtlsURL = "/user/workout/list/exercise";
export const deleteRunURL = "/user/run/delete";
export const deleteRideURL = "/user/ride/delete";
export const saveRunWithPic = "/user/run/save";
export const exerciseListURL = "/user/workout/exercises";
export const getStagesOf100DaysStepsChall = "/user/dashboard/stage";
export const updateEventProfile ="/user/profile/event";
export const updateGeneralDetails ="/user/profile/general";
export const getGroupOrCorporateURL = "/user/group/list";
export const updateGroupOrCorporateURL = "/user/group/change";
export const getHealthDataURL = "/user/profile/health";
export const updateHealthDataURL = "/user/profile/health";

//social login
export const isConnectedWithSocial ='/social/status';
export const socialSignUP = "/social/signup";
export const socialAuthenticate = "/social/authenticate";
export const socialConnect ="/social/connect";

//common search APIS
export const getCountryCode ="/common/list/countrycode";
export const searchCountry = "/common/search/country";
export const searchState = "/common/search/state";
export const searchCity = "/common/search/city";
export const searchPincode = "/common/search/pincode";
export const searchCorporate = "/common/search/corporate";
export const searhRunningGroup = "/common/search/group/running";
export const searchCyclingGroup = "/common/search/group/cycling";
export const commonGroupSearch = "/common/search/group";

//ticketing
export const allTransactionsURL = "/reg/payment/transactions";
export const charityTransactionsURL ="/event/charity/transactions";
export const downloadInvoice ="/reg/invoice/download";
export const downloadGroupCodes ="/reg/bulk/payment";
export const getCharityDtls ="/reg/payment/transaction/charity";

//connected app
export const getfitBitDetailsURL= "/fitbit/initialize/";
export const initalizeFitbit ="/fitbit/initialize/code";
export const initalizeGarmin ="/garmin/initialize";
export const initalizeStava ="/strava/initialize/web";
export const initalizeGoogleFit ="/googleFit/initialize";
export const initalizeMapMyRide ="/underarmour/initialize/code";
export const initalizeMapMyRun ="/underarmour/initialize/code";
export const initalizePolar ="/polar/initialize/code";
export const initalizeWahoo ="/wahoo/initialize/code";
export const activityPullStatus="/user/pull/request/status";
export const fetchSteps = "/user/pull/steps";
export const fetchActivities = "/user/pull/activities";
export const fetchAttempts="/user/pull/attempts";
export const requestActivity="/user/pull/request/activities";

//referral
export const getReferralCode ="/referral/list";
export const getReferalLinks="/referral/link";
export const getReferralUsages="/referral/usage";
export const getReferralEventList="/referral/enabled/list";

export const getRunsForList="/entry/window";

//Dashboard apis
export const getExploreEvents = "/event/list";
export const getEvents="/user/dashboard/list";
export const getEventsV2="/user/dashboard/list/v2";
export const eventStructure = "/user/dashboard/structure";
export const eventStructurePublic = "/public/event/structure";
export const userWidgets = "/user/dashboard/widgets";
export const userWidgetsPublic = "/public/event/widgets";
export const finisherLevel = "/widget/finisherLevel";
export const target="/user/dashboard/target";
export const setTarget ="/user/dashboard/target/save";
export const stageDailyGoalV2Url = "/stage/daily/goal/v2/days";
export const stageDailyGoalV2MembersUrl = "/stage/daily/goal/v2/members";

//past Event APIS
export const pastEvent="/user/dashboard/list/past";
export const pastEventPublic="/public/event/list/past";
export const pageStructure="/public/event/structure";

//Activity APIs
export const flagActivity= "/flag/activity";
export const flaggingReason = "/public/reasons";
export const flagSummary="/flag/summary";

//Overall Reports APIs
export const overallReportList ="/report/overall/list";
export const reportFilters = "/report/overall/filters";
export const reportDetails = "/report/overall/details";

// user stage APIS
export const stageDetails = "/stage/details";
export const activityList ="/user/activity/list";

//team stage APIS
export const teamsActivityList="/report/team/stage/activities";
export const teamStageDetails="/report/team/stage/details"
export const activeTeamList="/stage/active/team";
export const teamStageParticipantDetails ="/report/team/stage/member/details";

//Stage Report APIs
export const stageReportStats="/report/stage/stats";
export const stageReportList = "/report/stage/list";
export const stageParticipants = "/report/stage/participants";


//teams APIS
export const joinTeam = "/team/join";
export const createTeam = "/team/create";
export const invite ="/team/invite";
export const leaveTeam="/team/leave";
export const teamList="/team/list";
export const teamProperties ="/team/properties";
export const teamsReportFilter = "/report/team/filters";
export const teamReportList="/report/team/list";
export const teamMemberDetails ="/report/team/member/details";
export const teamActivityList= "/user/team/members";
export const teamStageReportList = "/report/team/stage/list";
export const teamDetails="/report/team/details";
export const teamStageReportStats="/report/team/stage/stats";
 

//health check
export const healthCheck = "/health/check"; 
export const csrfToken = "/csrf/token";

//Logout 
export const logout = "/terminate/session";

//widget APIS
export const attemptBasic = "/widget/attempt/basic";
export const distanceBasic = "/widget/distance/basic";
export const dayBasic ="/widget/day/basic";
export const paceBasic="/widget/pace";
export const pointsBasic="/widget/points";
export const speedBasic = "/widget/speed";
export const stepsBasic= "/widget/steps/basic";
export const targetBasic = "/widget/target";
export const timeBasic="/widget/time/basic";
export const rankBasic="/widget/rank";
export const elevationGain="/widget/elevation";
export const challengesCompleted="/widget/challenges";
export const historicSummary="/widget/historic/journey";
export const historicTrends="/widget/historic/trends";
export const summary ="/widget/summary";
export const getEventActivitiesURL = "/user/activity/list";

//EventChallenges
export const eventChallenges="/widget/event/challenges";

//Event Badge
export const getBadges="/public/stage/details";

//Achievement
export const metaDetails="/meta/detail";
export const bannerDetails="/banner/detail";
export const certificateDetails="/certificate/detail";
export const scorecardDetails="/scorecard/detail";

export const bannerDetailsV2="/banner/detail/v2";
export const certificateDetailsV2="/certificate/detail/v2";
export const scorecardDetailsV2="/scorecard/detail/v2";

export const downLoadScoreCard="/scorecard/download";
export const downLoadCertificate="/certificate/download";
export const downLoadBanner="/banner/download";
export const achievementBadgesURL = "/widget/achievements";

//user Splits
export const splits="/user/activity/splits";

//LeaderBoard widget apis
export const getLeaderBoardEntities  ="/public/event/widgets";
export const getLeaderBoardList="/report/leaderboard/list";
export const getMember="/report/leaderboard/members";
export const getMemberDetails = "/report/leaderboard/member/details";


